"use strict";

import { historyConstants } from "../_constants";

const INITIAL_ACCOUNT_DATA_STATE = {
  transactionHistoryList: {
    list: [],
    isEmpty: false,
  },
  isTransactionDetailLoading: false,
  transactionDetail: null,
};

export function history(state = INITIAL_ACCOUNT_DATA_STATE, action) {
  switch (action.type) {
    case historyConstants.TRANSACTION_HISTORY_LIST_COMPLETE:
      let empty = false;
      if (action.payload.list.length == 0) {
        empty = true;
      }
      return {
        ...state,
        isTransactionDetailLoading: true,
        transactionHistoryList: !action.payload.isFiltering
          ? {
              list: [
                ...state.transactionHistoryList.list,
                ...action.payload.list,
              ],
              isEmpty: empty,
            }
          : {
              list: [...action.payload.list],
              isEmpty: empty,
            },
      };

    case historyConstants.TRANSACTION_HISTORY_DETAIL_REQUEST:
      return {
        ...state,
        isTransactionDetailLoading: true,
      };

    case historyConstants.TRANSACTION_HISTORY_DETAIL_COMPLETE:
      return {
        ...state,
        transactionDetail: {
          ...action.payload,
        },
        isTransactionDetailLoading: false,
      };

    case historyConstants.TRANSACTION_HISTORY_DETAIL_ERROR:
      return {
        ...state,
        transactionDetail: null,
        isTransactionDetailLoading: false,
      };

    case historyConstants.TRANSACTION_HISTORY_DETAIL_REMOVE:
      return {
        ...state,
        transactionDetail: null,
      };
  }

  return state;
}
